<script lang="ts">
    import { Container, Row, Col } from "svelte-materialify/src";
    import Education from "./Education.svelte";
    import Interests from "./Interests.svelte";
    import Languages from "./Languages.svelte";
    import Present from "./Present.svelte";
    import Roots from "./Roots.svelte";
    import Technologies from "./Technologies.svelte";
</script>

<h6 class="text-h6 primary-text">About</h6>

<Container>
    <Row>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Roots /></Col>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Education /></Col>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Present /></Col>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Languages /></Col>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Technologies /></Col>
        <Col cols={12} xl={4} lg={4} md={4} sm={12}><Interests /></Col>
    </Row>
</Container>
